import { generateSheetTicks } from '@ezchops/musicsheet';
import { useCallback, useMemo, useRef } from 'react';
import { useScheduler } from './eventScheduler';
export function useSheetPlayerBot(sheet, timing, clock, clockState, hitScheduler) {
    const voices = useMemo(() => {
        if (sheet != null) {
            return [...generateSheetTicks(sheet)].flatMap((notes, tick) => {
                const timestamp = timing.tickTimestamp(tick);
                return notes.notes.flatMap((note) => {
                    if (note.pitch == null) {
                        return [];
                    }
                    const value = note.dynamics == 'ghost' ? 0.5 : note.dynamics == 'accent' ? 1 : 0.8;
                    return [{ note: note.pitch, value, timestamp }];
                });
            });
        }
        else {
            return [];
        }
    }, [sheet, timing]);
    const cursor = useRef(0);
    const reset = useCallback(() => {
        cursor.current = 0;
    }, []);
    const seek = useCallback((timestamp) => {
        cursor.current = voices.findIndex(voice => voice.timestamp > timestamp);
    }, [voices]);
    useScheduler(timing, clock, clockState, voices, hitScheduler, reset, seek, cursor);
}
//# sourceMappingURL=sheetPlayerBot.js.map